import { useAppSelector } from 'app/hooks';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import StatusHeader from 'components/common/StatusHeader';
import CONST_SUB_GENRE from 'features/SubGenre/constans';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Sortable, SubGenre } from '../../models/SubGenre';
import './List.scss';
import Filter from './components/Filter';
import TableList from './components/TableList';
import service from './services';

function List() {
  const { t } = useTranslation();
  const history = useHistory();
  const [name, setName] = useState('');
  const [fairFlg, setFairFlg] = useState(CONST_SUB_GENRE.CONST_SUB_GENRE_FILTER.ALL);
  const [deleteFlg, setDeleteFlg] = useState(CONST_SUB_GENRE.CONST_SUB_DEL_GENRE_FILTER.HIDE_DEL);
  const [dataTable, setDataTable] = useState<SubGenre[] | []>();
  const [sort, setSort] = useState<Sortable>({ name: 0, note: 0, fair_flg: 0 });

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  // call API
  async function filterAPI(name: string, fairFlg: number) {
    await service
      .getSubGenres(name, fairFlg, deleteFlg)
      .then((result) => {
        setDataTable(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // first load page
  useEffect(() => {
    async function getDataTable(name: string) {
      filterAPI(name, fairFlg);
    }
    getDataTable(name);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  // search name
  function handleFilter() {
    filterAPI(name, fairFlg);
  }

  return (
    <div className="page-wrapper">
      <div className="page-header">
        <StatusHeader onAction={() => history.push('/')} />
      </div>
      <div className={`page-main ${isEditMode ? 'reedit-mode-wrapper' : ''}`}>
        <div className="page-content">
          <FeatureTitleBar title={t('SubGenre.Title')} />
          <Card className="mb-2">
            <Filter
              setName={setName}
              setFairFlg={setFairFlg}
              handleFilter={handleFilter}
              setDeleteFlg={setDeleteFlg}
              name={name}
              fairFlg={fairFlg}
              deleteFlg={deleteFlg}
            ></Filter>
          </Card>

          <Card className="card border-0">
            {dataTable && (
              <TableList dataTable={dataTable} setSort={setSort} sort={sort} setDataTable={setDataTable}></TableList>
            )}
          </Card>
        </div>
      </div>
    </div>
  );
}
export default List;
